import { render } from "./UpdateQwilrDataSource.vue?vue&type=template&id=f6c6fc0c&scoped=true"
import script from "./UpdateQwilrDataSource.vue?vue&type=script&lang=js"
export * from "./UpdateQwilrDataSource.vue?vue&type=script&lang=js"

import "./UpdateQwilrDataSource.vue?vue&type=style&index=0&id=f6c6fc0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c6fc0c"]])

export default __exports__